"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var textResolver_1 = require("../helpers/textResolver");
var page_1 = require("./page");
var multiPage_1 = require("./multiPage");
var parse_1 = require("../helpers/parse");
var Preview = /** @class */ (function () {
    function Preview(config, appState, book, $parse, resizer, glyphMatcher, testFeatures, $timeout) {
        this.config = config;
        this.appState = appState;
        this.book = book;
        this.$parse = $parse;
        this.resizer = resizer;
        this.glyphMatcher = glyphMatcher;
        this.testFeatures = testFeatures;
        this.imageMaxUpscale = 1.2;
        this.timeout = $timeout;
        this.imageSizes = this.config.preview.meta.sizes;
        this.imageSizePreset = this.config.params.resolution;
        this.totalPages = this.config.preview.meta.totalPages;
        this.multipages = this.getMultiPages();
        this.pages = this.getPages();
        this.overlayHistory = [];
        // sort image-sizes:
        this.imageSizes.sizes.sort(function (a, b) {
            if (a.scale < b.scale) {
                return -1;
            }
            if (a.scale > b.scale) {
                return 1;
            }
            return 0;
        });
        // match preset of image-size:
        if (this.imageSizePreset) {
            for (var _i = 0, _a = this.imageSizes.sizes; _i < _a.length; _i++) {
                var size = _a[_i];
                if (size.id === this.imageSizePreset) {
                    this.imageSize = size;
                    break;
                }
            }
            // Reset preset if not matching config:
            if (!this.imageSize) {
                this.imageSizePreset = null;
            }
        }
        this.setActive(this.pages[0].id, false);
    }
    Preview.prototype.getMultiPages = function () {
        var multipages = [];
        for (var i = 0; i < this.config.preview.pages.length; i++) {
            if (this.config.preview.pages[i].type === 'multi-page') {
                multipages.push({
                    id: this.config.preview.pages[i].id,
                    condition: this.config.preview.pages[i].condition
                });
            }
        }
        return multipages;
    };
    Preview.prototype.getPages = function () {
        var pages = [];
        var index = 0;
        var multipageIndex = 1;
        for (var _i = 0, _a = this.config.preview.pages; _i < _a.length; _i++) {
            var page = _a[_i];
            if (page.type === 'multi-page') {
                var multiPages = this.$parse(page.condition)(this.book);
                for (var _b = 0, multiPages_1 = multiPages; _b < multiPages_1.length; _b++) {
                    var glyph = multiPages_1[_b];
                    var glyphDetail = this.glyphMatcher.getGlyphDetails(glyph);
                    var config = {
                        id: page.id + multipageIndex / 100,
                        type: page.type,
                        glyph: glyphDetail.value,
                        zoom: glyphDetail.zoom
                    };
                    var currentPage = new multiPage_1.default(config, this.appState, index, this.book, this.resizer, this.config.params.langBook, this.testFeatures);
                    pages.push(currentPage);
                    index++;
                    multipageIndex++;
                }
            }
            else {
                var currentPage = new page_1.default(page, this.appState, index, this.book, this.resizer, this.config.params.langBook, this.testFeatures);
                pages.push(currentPage);
                index++;
            }
        }
        return pages;
    };
    Preview.prototype.getFirstPage = function () {
        var pages = this.getPages();
        return pages[0];
    };
    Preview.prototype.updatePages = function () {
        this.direction = 'none';
        this.pages = this.getPages();
    };
    Preview.prototype.getActive = function () {
        return this.currentPage;
    };
    Preview.prototype.setActive = function (id, animate) {
        animate = typeof animate === 'undefined' ? true : animate;
        var currentPageId = this.currentPage ? this.currentPage.id : undefined;
        if (id === currentPageId) {
            return;
        }
        else if (!animate) {
            this.direction = 'none';
        }
        else {
            this.direction = id > currentPageId ? 'left' : 'right';
        }
        this.currentPage = this.pages.find(function (page) { return page.id === id; });
    };
    Preview.prototype.getImageSize = function () {
        return this.imageSize;
    };
    Preview.prototype.setActiveTab = function (tab) {
        if (tab.$previewPage) {
            tab.previewPage = parse_1.evaluateCondition(tab.$previewPage, Object.assign({
                hasFeature: this.testFeatures.hasFeature,
                testFeatures: this.testFeatures.testFeatures
            }, this.book));
        }
        if (typeof tab.previewPage === 'number') {
            this.setActive(tab.previewPage, true);
        }
        this.currentTab = tab;
    };
    Preview.prototype.setActiveForm = function (form) {
        if (typeof form.previewPage === 'number') {
            this.setActive(form.previewPage, true);
        }
        this.currentForm = form;
    };
    Preview.prototype.zoomPage = function (pageId, zoomIn, scale, x, y) {
        if (this.currentPage.id === pageId) {
            this.currentPage.zoomPage(zoomIn, scale, x, y);
        }
    };
    Preview.prototype.showOverlay = function (option) {
        var _this = this;
        if (this.currentOverlay === option.value) {
            return true;
        }
        var result = false, currentFormId = this.currentForm ? this.currentForm.id : undefined, currentTabId = this.currentTab ? this.currentTab.id : undefined, elementHistory = this.overlayHistory.find(function (element) {
            return element.layer === option.value;
        });
        if (!elementHistory) {
            elementHistory = { layer: option.value, triggeredTabs: [], triggeredForms: [] };
            this.overlayHistory.push(elementHistory);
        }
        if (currentTabId && option.group && option.group.includes(currentTabId)) {
            if (!elementHistory.triggeredTabs.includes(currentTabId)) {
                this.currentOverlay = option.value;
                elementHistory.triggeredTabs.push(currentTabId);
                result = true;
            }
        }
        if (currentFormId && option.form && option.form.includes(currentFormId)) {
            if (!elementHistory.triggeredForms.includes(currentFormId)) {
                this.currentOverlay = option.value;
                elementHistory.triggeredForms.push(currentFormId);
                result = true;
            }
        }
        if (result) {
            this.timeout(function () {
                if (_this.currentOverlay === option.value) {
                    _this.currentOverlay = undefined;
                }
            }, 3000);
        }
        return result;
    };
    Preview.prototype.onScreenChange = function (screen) {
        if (this.imageSizePreset) {
            return;
        }
        var imageSize = this.imageSizes.sizes[0];
        for (var _i = 0, _a = this.imageSizes.sizes; _i < _a.length; _i++) {
            var size = _a[_i];
            if (this.imageSizes.width / size.scale * this.imageMaxUpscale
                > screen.previewPageWidth * screen.pixelDensity) {
                imageSize = size;
            }
        }
        if (this.imageSize !== imageSize) {
            this.imageSize = imageSize;
            this.resizer.resize();
        }
    };
    return Preview;
}());
exports.Preview = Preview;
function PreviewDirective(config, preview, book, appState, $parse) {
    return {
        templateUrl: config.params.base + "templates/preview/preview.html",
        scope: true,
        controller: /** @class */ (function () {
            function PreviewController($scope) {
                this.appState = appState;
                if (preview.multipages.length) {
                    $scope.$watch(function () {
                        var watches = [];
                        for (var _i = 0, _a = preview.multipages; _i < _a.length; _i++) {
                            var multiPage = _a[_i];
                            watches.push($parse(multiPage.condition)(book));
                        }
                        return watches;
                    }, function (newValue, oldValue) {
                        preview.updatePages();
                    }, true);
                }
            }
            PreviewController.prototype.showOverlay = function (option) {
                return preview.showOverlay(option);
            };
            PreviewController.prototype.getPages = function () {
                return preview.pages;
            };
            PreviewController.prototype.getImageDirectory = function () {
                return config.params.assets + "/" + preview.getImageSize().directory;
            };
            PreviewController.prototype.getImageSizeID = function () {
                return preview.getImageSize().id;
            };
            PreviewController.prototype.getTotalPages = function () {
                return preview.totalPages;
            };
            PreviewController.prototype.getPageCount = function () {
                return preview.pages.length;
            };
            PreviewController.prototype.getPageNumber = function () {
                return preview.currentPage.index + 1;
            };
            PreviewController.prototype.getActive = function () {
                return preview.currentPage.id;
            };
            PreviewController.prototype.setActive = function (id) {
                preview.setActive(id);
            };
            PreviewController.prototype.setPrevPage = function () {
                var index = this.getIndexById(this.getActive());
                index--;
                index += this.getPageCount();
                index %= this.getPageCount();
                this.setActive(this.getPages()[index].id);
            };
            PreviewController.prototype.setNextPage = function () {
                var index = this.getIndexById(this.getActive());
                index++;
                index %= this.getPageCount();
                this.setActive(this.getPages()[index].id);
            };
            PreviewController.prototype.getIndexById = function (id) {
                var index = -1;
                for (var i = 0; i < this.getPages().length; i++) {
                    if (this.getPages()[i].id === id) {
                        index = i;
                        break;
                    }
                }
                return index;
            };
            PreviewController.prototype.getDirection = function () {
                return preview.direction;
            };
            PreviewController.prototype.isFullsize = function () {
                return this.appState.screen.fullPreview || false;
            };
            return PreviewController;
        }()),
        controllerAs: 'previewCtrl',
        link: function (scope) {
            scope.$watch(function () { return appState.screen; }, function (screen) { preview.onScreenChange(screen); }, true);
        }
    };
}
var page_2 = require("./page");
exports.default = angular.module('pb.preview', [])
    .service('preview', Preview)
    .service('textResolver', textResolver_1.default)
    .directive('pbPreview', PreviewDirective)
    .directive('pbPage', page_2.PageDirective)
    .directive('pbLayer', page_2.LayerDirective)
    .directive('pbLayerImage', page_2.LayerImageDirective)
    .directive('pbLayerText', page_2.LayerTextDirective)
    .directive('pbLayerUpload', page_2.LayerUploadDirective)
    .directive('pbLayerOverlay', page_2.LayerOverlayDirective);
